import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=3985b73c"
import script from "./NotAuthorized.vue?vue&type=script&lang=ts"
export * from "./NotAuthorized.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports